import { useState } from "react";
import WoSectionCard from "../common/WoSectionCard";
import Pos from "./Pos";

// Purchase Orders section as an independent card matching the proposals/forms look.
function WoPos({ woId, refreshToken, poEditHandle, onPreviewAttachments }) {
  const [count, setCount] = useState(0);

  return (
    <WoSectionCard title="Purchase Orders" count={count}>
      <Pos
        woId={woId}
        refreshToken={refreshToken}
        poEditHandle={poEditHandle}
        onPreviewAttachments={onPreviewAttachments}
        onCount={setCount}
      />
    </WoSectionCard>
  );
}

export default WoPos;
